import TableDisplay from './TableDisplay-container';

export default TableDisplay;
